'use strict';

const CommentItem = require('./comment-item.js');

function Reply (data) {
  CommentItem.apply(this, Array.prototype.slice.call(arguments));

  this.tpl = {
    comment: '[data-template="community-reply"]',
    avatar: '[data-template="community-reply-avatar"]',
    authorLink: '[data-template="community-reply-author-link"]',
    author: '[data-template="community-reply-author"]',
    datetime: '[data-template="community-reply-datetime"]',
    content: '[data-template="community-reply-content"]'
  };

  this.date = new Date(data.CreatedAt);
  this.id = this.date.getTime();

  this.refs = {
    comment: '[data-ref="community-reply-' + this.id + '"]',
    avatar: '[data-ref="community-reply-avatar-' + this.id + '"]',
    authorLink: '[data-ref="community-reply-author-link-' + this.id + '"]',
    author: '[data-ref="community-reply-author-' + this.id + '"]',
    datetime: '[data-ref="community-reply-datetime-' + this.id + '"]',
    content: '[data-ref="community-reply-content-' + this.id + '"]'
  };
}

Reply.prototype = new CommentItem();

module.exports = Reply;



//////////////////
// WEBPACK FOOTER
// ./_js/comments/reply.js
// module id = 34
// module chunks = 0